module.exports = __webpack_public_path__ + "img/wx_android.ff702bc3.png";